import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject, defer, Observable } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class CurrenciespageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  currenciesData: any;

  private currenciesHeroSubject$ = new BehaviorSubject<any>(null);
  public currenciesHero$ = this.currenciesHeroSubject$.asObservable();
  private currenciesCoverageSubject$ = new BehaviorSubject<any>(null);
  public currenciesCoverage$ = this.currenciesCoverageSubject$.asObservable();
  private currenciesFeaturesSubject$ = new BehaviorSubject<any>(null);
  public currenciesFeatures$ = this.currenciesFeaturesSubject$.asObservable();
  private currenciesFaqSubject$ = new BehaviorSubject<any>(null);
  public currenciesFaq$ = this.currenciesFaqSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getCurrenciesPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
          limit: 300,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];

        this.currenciesData = mod.filter(
          x => x?.fields['id'] == PageId.coverageCurrenciesAlt
        );
        const heroData = this.currenciesData[0].fields.heroContentPanel.fields;
        if (heroData) {
          this.currenciesHeroSubject$.next(heroData);
        }
        const coverageData = this.currenciesData[0].fields.coverage.fields;
        if (coverageData) {
          this.currenciesCoverageSubject$.next(coverageData);
        }
        const featuresData = this.currenciesData[0].fields.features[0].fields;
        if (featuresData) {
          this.currenciesFeaturesSubject$.next(featuresData);
        }
        const faqsData = this.currenciesData[0].fields.faq.fields;
        if (faqsData) {
          this.currenciesFaqSubject$.next(faqsData);
        }
        const getStarted =
          this.currenciesData[0].fields.getStartedContentPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
}
